export function setCookie({ key, value, timeMinSec, Expired, domain=location.host }) {
  var exp = new Date()
  exp.setTime(exp.getTime() + timeMinSec)
  if (Expired) {
    document.cookie = `${key}=${escape(value)};expires=${Expired};path=/;domain=${domain};`
  } else if (timeMinSec) {
    document.cookie = `${key}=${escape(
      value
    )};expires=${exp.toGMTString()};path=/;domain=${domain};`
  }
}

export function getCookie(key) {
  var name = key + '='
  var cookieArray = document.cookie.split(';')
  for (var i = 0; i < cookieArray.length; i++) {
    var c = cookieArray[i].trim()
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length)
  }
  return undefined
}

export function delCookie(key) {
  setCookie({
    key,
    value: '',
    Expired: new Date('Thu, 01 Jan 1970 00:00:00 GMT:')
  })
}

export default {
  setCookie,
  getCookie,
  delCookie
}
